import { render, staticRenderFns } from "./Cloud.vue?vue&type=template&id=c84ab348&scoped=true&"
import script from "./Cloud.vue?vue&type=script&lang=ts&"
export * from "./Cloud.vue?vue&type=script&lang=ts&"
import style0 from "./Cloud.vue?vue&type=style&index=0&id=c84ab348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84ab348",
  null
  
)

export default component.exports